import { intervalToDuration, isSameDay } from 'date-fns'
import { _, date as date_formatter, time as time_formatter, getDateFormatter } from 'svelte-i18n';
import { readable, get } from 'svelte/store';

export const dayMS = 1000 * 60 * 60 * 24; // number of milliseconds in a day

export const time = readable(new Date(), function start(set) {
  const interval = setInterval(() => {
    set(new Date());
  }, 1000);

  return function stop() {
    clearInterval(interval);
  };
});

export const time_update_minute = readable(new Date(), function start(set) {
  let now = new Date();
  now.setSeconds(0);
  now.setMinutes(now.getMinutes() + 1);
  let interval;
  let do_stop = false;

  // Align first event with the next minute rollover.
  setTimeout(() => {
    if (do_stop) return;
    set(new Date());
    interval = setInterval(() => {
      set(new Date());
    }, 60 * 1000);
  }, now.getTime() - (new Date()).getTime());


  return function stop() {
    do_stop = true;
    clearInterval(interval);
  };
});

export const today = readable(midnight(new Date()), function start(set) {
  let today = midnight(new Date())

  return time_update_minute.subscribe((now) => {
    if (!isSameDay(now, today)) {
      today = midnight(now)
      set(today)
    }
  })
})

export const format_elapsed = (date: Date, ref_date: Date) => {
  ref_date = ref_date ? ref_date : new Date();
  var t = (ref_date.getTime() - date.getTime()) / 1000;
  return format_duration(t);
}

export const format_duration_msf = (t: number) => {
  if (t == null) {
    return "";
  }
  let minute = 60;
  let hour = 3600;

  let seconds = Math.round(t);
  let minutes = Math.round(t / minute);
  let hours = Math.round(t / hour);

  let fmt = get(_);
  if (hours >= 2) return fmt("duration.hours", { values: { hours: hours } })
  else if (minutes >= 2) return fmt("duration.minutes", { values: { minutes: minutes } });
  else return fmt("duration.seconds", { values: { seconds: seconds } });

}
export const format_duration = (t: number) => {
  if (t == null || t < 0) {
    return "";
  }
  let minute = 60;
  let hour = 3600;

  let lz = (v) => v.toString().padStart(2, '0');
  let seconds = lz(Math.floor(t) % minute);
  let minutes = lz(Math.floor(t / minute) % minute);
  let hours = Math.floor(t / hour);

  return hours == 0 ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`;
}
export const format_duration_b = (t: number) => {
  if (t == null) {
    return "";
  }

  let minute = 60;
  let hour = 3600;

  let formatter = get(_);
  if (t < 0) {
    return "";
  } else if (t < 2 * minute) {
    return formatter("duration.seconds", { values: { seconds: t } });
  } else if (t < hour) {
    return formatter("duration.minutes", { values: { minutes: Math.floor(t / minute) } });
  } else {
    let hours = Math.floor(t / hour);
    let minutes = Math.floor(t / minute - hours * minute);
    return formatter("duration.hours_and_minutes", { values: { hours: hours, minutes: minutes } });
  }
}
export const parse_duration = (t: any) => {
  let str = String(t);
  if (str.includes(":")) {
    var multiplier = 1;
    var num = 0;
    str.split(":").reverse().forEach(v => {
      num += Number(v) * multiplier;
      multiplier *= 60;
    });
    return num;
  } else {
    return t;
  }
}
export const validate_duration = (event) => {
  let input: HTMLInputElement = event.target;
  let val = input.value
  let fmt = get(_);
  if (val == null || val.length == 0) {
    input.setCustomValidity(fmt("sessions.errors.required_input"));
    return;
  }
  let parsed = parse_duration(val);
  if (isNaN(parsed)) {
    input.setCustomValidity(fmt("sessions.errors.invalid_input"));
  } else {
    input.setCustomValidity("");
  }
  return val;
}
export const format_daymonth = (date: Date, ref_date: Date): string => {
  if (!date) return ''

  const formatter = get(_);
  const start_of_day = new Date(ref_date);
  start_of_day.setHours(0, 0, 0, 0);
  const end_of_day = new Date(ref_date);
  end_of_day.setHours(23, 59, 59, 999);
  const tomorrow = new Date(ref_date.getTime() + 24 * 3600 * 1000)
  tomorrow.setHours(23, 59, 59, 999);

  if (date.getTime() < start_of_day.getTime()) {
    return get(date_formatter)(date, { weekday: "long", day: "numeric", month: "long" });
  } else if (date.getTime() < end_of_day.getTime()) {
    return formatter("time.today");
  } else if (date.getTime() < tomorrow.getTime()) {
    return formatter("time.tomorrow");
  } else {
    return get(date_formatter)(date, { weekday: "long", day: "numeric", month: "long" });
  }
}

export const format_time_of_day = (date: Date, ref_date: Date) => {
  return get(time_formatter)(date);
}

export const format_timespan = (date: Date, ref_date: Date) => {
  if (!date) return null;
  ref_date = ref_date ? ref_date : new Date();
  var seconds_difference = Math.round((date.getTime() - ref_date.getTime()) / 1000);

  let end_of_day = new Date(ref_date);
  end_of_day.setHours(23, 59, 59, 999);
  let tomorrow = new Date(ref_date.getTime() + 24 * 3600 * 1000)
  tomorrow.setHours(23, 59, 59, 999);

  let minute = 60;
  let hour = 3600;
  let hours12 = 12 * 3600;

  let formatter = get(_);

  if (seconds_difference < 0) {
    //return formatter("time.seconds", {values: {seconds: 0}});
    return null;
  } else if (seconds_difference < 2 * minute) {
    return formatter("time.seconds", { values: { seconds: seconds_difference } });
  } else if (seconds_difference < hour) {
    return formatter("time.minutes", { values: { minutes: Math.floor(seconds_difference / minute) } });
  } else if (seconds_difference < hours12) {
    let hours = Math.floor(seconds_difference / hour);
    let minutes = Math.floor(seconds_difference / minute - hours * minute);
    if (hours < 2) {
      return formatter("time.hour_singular", { values: { minutes: minutes } });
    } else {
      return formatter("time.hours", { values: { hours: hours, minutes: minutes } });
    }
  } else if (date.getTime() < end_of_day.getTime()) {
    return formatter("time.today_at", { values: { time: get(time_formatter)(date.getTime()) } });
  } else if (date.getTime() < tomorrow.getTime()) {
    return formatter("time.tomorrow_at", { values: { time: get(time_formatter)(date.getTime()) } });
  } else {
    return formatter("time.date_at", {
      values: {
        date: get(date_formatter)(date, { format: "full" }),
        time: get(time_formatter)(date)
      }
    });

  }
}

export function formatDurationSimple(milliseconds: number) {
  const duration = intervalToDuration({ start: 0, end: (milliseconds)})
  let parts: string[] = []
  if (duration.hours > 0) parts.push(`${duration.hours}h`)
  if (duration.minutes > 0) parts.push(`${duration.minutes}m`)
  return parts.join(' ')
}

export const format_timespan_multiline = (date: Date, ref_date: Date) => {
  ref_date = ref_date ? ref_date : new Date();
  var seconds_difference = Math.round((date.getTime() - ref_date.getTime()) / 1000);

  let start_of_day = new Date(ref_date);
  start_of_day.setHours(0, 0, 0, 0);
  let end_of_day = new Date(ref_date);
  end_of_day.setHours(23, 59, 59, 999);
  let tomorrow = new Date(ref_date.getTime() + 24 * 3600 * 1000)
  tomorrow.setHours(23, 59, 59, 999);

  let minute = 60;
  let hour = 3600;
  let hours12 = 12 * 3600;

  let formatter = get(_);

  let lines = [];

  if (seconds_difference >= 0 && seconds_difference < 3 * hours12) {
    if (seconds_difference < 2 * minute) {
      lines[0] = formatter("time.seconds", { values: { seconds: seconds_difference } });
    } else if (seconds_difference < hour) {
      lines[0] = formatter("time.minutes", { values: { minutes: Math.floor(seconds_difference / minute) } });
    } else {
      let hours = Math.floor(seconds_difference / hour);
      let minutes = Math.floor(seconds_difference / minute - hours * minute);
      if (hours < 2) {
        lines[0] = formatter("time.hour_singular", { values: { minutes: minutes } });
      } else {
        lines[0] = formatter("time.hours", { values: { hours: hours, minutes: minutes } });
      }
    }
  } else if (date > start_of_day && date <= end_of_day) {
    lines[0] = formatter("time.today");
  } else if (date > end_of_day && date <= tomorrow) {
    lines[0] = formatter("time.tomorrow");
  } else {
    //lines[0] = get(date_formatter)(date, {weekday: "long"});
    //lines[0] = get(date_formatter)(date, {format: "full", year: null});
    if (date.getFullYear() == (new Date()).getFullYear()) {
      lines[0] = get(date_formatter)(date, { weekday: "long", month: "long", day: "numeric" });
    } else {
      lines[0] = get(date_formatter)(date, { format: "full" });
    }
    /*
    return formatter("time.date", {values: {
        date: get(date_formatter)(date, {format: "full"}),
        time: get(time_formatter)(date)
    }});*/

  }
  lines.push(get(time_formatter)(date));
  return lines;
}

export const utcSecondsToDateString = (seconds) => {
  let d = new Date(0);
  d.setUTCSeconds(seconds);
  d.toString();
  return d;
}

export const addDays = (date: Date, days: number) => {
  let dateCopy: Date = new Date(date);
  if (days == 0) return dateCopy;
  dateCopy.setDate(dateCopy.getDate() + days);
  return dateCopy;
}

export const daysBetween = (d1: Date, d2: Date) => {
  return Math.round((d2.getTime() - d1.getTime()) / dayMS)
}

export class LocalDate {
  // [Year, Month, Day]
  // NOTE: Month is 0-indexed
  ymd: number[]
  constructor(ymd: number[]) {
    this.ymd = ymd
  }
  static create(date: Date) {
    return new LocalDate([date.getFullYear(), date.getMonth(), date.getDate()])
  }
  static _ymdFromString(txt: string): number[] {
    const parts = txt.split('-');
    return [+parts[0], +parts[1] - 1, +parts[2]];
  }
  static parse(txt: string) {
    return new LocalDate(LocalDate._ymdFromString(txt))
  }
  static toDate(txt: string): Date {
    return new Date(...(this._ymdFromString(txt) as []))
  }
  static atNoon(txt: string): Date {
    let date = new Date(...(this._ymdFromString(txt) as []))
    date.setHours(12, 0, 0)
    return date
  }
  toDate(): Date {
    return new Date(...(this.ymd as []))
  }
  static format(date: Date) {
    return LocalDate.create(date).format()
  }
  format(): string {
    return `${this.ymd[0]}-${(this.ymd[1] + 1).toString().padStart(2, '0')}-${this.ymd[2].toString().padStart(2, '0')}`
  }
}

export function midnight(date: Date) {
  let out = new Date(date);
  out.setHours(0, 0, 0, 0);
  return out;
}
